import { render, staticRenderFns } from "./panelCatalogosCatastrales.vue?vue&type=template&id=56886886&"
import script from "./panelCatalogosCatastrales.vue?vue&type=script&lang=js&"
export * from "./panelCatalogosCatastrales.vue?vue&type=script&lang=js&"
import style0 from "./panelCatalogosCatastrales.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports